import { Injectable, SkipSelf, Optional } from '@angular/core';
import { LoadingService, LoadingConfig, LoadingComponent } from '@farris/ui-loading';
import { HideEventService } from './hide-event.service';
import { AppContext, FrameContext } from '@farris/devkit';
// tslint:disable: no-string-literal
/**
 * å è½½æç¤ºHelper
 * 1ãåè£@farris/uiçLoadingServiceï¼
 * 2ãæä¾éå¯¹è¡¨åçå¿«æ·æ¹æ³ï¼
 */
@Injectable()
class FormLoadingService {
  private static isSuspend = false;
  /**
   * å è½½ä¸­ç»ä»¶å®ä¾
   */
  private loadingCmp: LoadingComponent;

  /**
   * å»¶è¿loadingå®æ¶å¨
   */
  private loadingTimerIds: any[] = [];

  /**
   * å¼ºå¶æ¾ç¤ºï¼ä¸è½éè
   */

  /**
   * æé å½æ°
   * æ³¨å¥@farris/uiçLoadingService
   */
  constructor(
    private loadingService: LoadingService,
    @Optional() private hideEventService: HideEventService,
    @Optional() private applicationContext: AppContext,
  ) {
    if (hideEventService) {
      this.hideEventService.hideEvent.subscribe(
        result => {
          this.hide();
        }
      );
    }
  }
  public setSuspend(flag: boolean) {
    FormLoadingService.isSuspend = flag;
  }
  /**
   * æ¾ç¤ºå è½½ä¸­
   */
  public show(configOrMessage?: any): LoadingComponent {
    if (FormLoadingService.isSuspend === true) {
      return;
    }
    if (this.loadingCmp) {
      this.loadingCmp.close();
      this.loadingCmp = null;
    }
    this.registerService();
    const loadingConfig = this.buildLoadingConfig(configOrMessage);
    this.loadingCmp = this.loadingService.show(loadingConfig);
    return this.loadingCmp;
  }

  /**
   * å»¶è¿æ¾ç¤ºLoading
   */
  public showLoadingWithDelay(delayTime: number, configOrMessage?: any): any {
    // this.show(configOrMessage);
    const timerId = setTimeout(() => {
      this.show(configOrMessage);
    }, delayTime);
    this.loadingTimerIds.push(timerId);
    this.registerService();
    return timerId;
  }

  /**
   * éèå»¶è¿çLoading
   */
  public hideDelayLoading(timerIdToClear: any) {
    this.clearLoadingTimer(timerIdToClear);
    this.hide();
  }

  /**
   * æé LoadingConfig
   * @param configOrMessage éç½®å¯¹è±¡ææ¶æ¯å­ç¬¦ä¸²
   */
  private buildLoadingConfig(configOrMessage: any): LoadingConfig {
    let loadingConfig: LoadingConfig;
    if (!!configOrMessage) {
      if (typeof configOrMessage === 'object') {
        loadingConfig = configOrMessage;
      } else {
        loadingConfig = { 'message': configOrMessage };
      }
    } else {
      loadingConfig = {};
    }
    if (!loadingConfig.hasOwnProperty('delay')) {
      loadingConfig.delay = 0;
    }
    return loadingConfig;
  }

  /**
   * å³é­ææloading
   */
  public clearAll() {
    FormLoadingService.isSuspend = false;
    window.setTimeout(() => {
      this.loadingService.clearAll();
    }, 350);
    this.loadingCmp = null;
    this.clearAllLoadingTimers();
    this.destroy();
  }

  /**
   * æ¸ç©ºLoadingå®æ¶å¨
   */
  private clearLoadingTimer(timerIdToClear: any) {
    clearTimeout(timerIdToClear);
    this.loadingTimerIds = this.loadingTimerIds.filter((timerId: any) => {
      return timerId !== timerIdToClear;
    });
  }

  /**
   * æ¸ç©ºææLoadingå®æ¶å¨
   */
  private clearAllLoadingTimers() {
    this.loadingTimerIds.forEach((timerId: any) => {
      this.clearLoadingTimer(timerId);
    });
  }

  /**
   * éèå è½½ä¸­
   */
  public hide() {
    if (!this.loadingCmp) {
      this.destroy();
      return;
    }
    if (FormLoadingService.isSuspend === true) {
      return;
    }
    this.loadingCmp.close();
    this.loadingCmp = null;
    this.destroy();
  }
  /**
   * éæ¯loadingService
   */
  public destroy() {
    if (FormLoadingService.isSuspend === true) {
      return;
    }
    const services: any[] = window['DEVKIT_LOADING_SERVICE'] || [];
    if (services && Array.isArray(services) && services.length > 0) {
      services.forEach((service: FormLoadingService) => {
        if (service) {
          service.clearAllLoadingTimers();
          if (service.loadingCmp) {
            service.loadingCmp.close();
            service.loadingCmp = null;
        }
        }
      });
    }
    window['DEVKIT_LOADING_SERVICE'] = [];
  }

  /**
   * æ³¨åææçLoadingServiceå®ä¾
   */
  private registerService() {
    const services: any[] = window['DEVKIT_LOADING_SERVICE'] || [];
    services.push(this);
    window['DEVKIT_LOADING_SERVICE'] = services;
  }
}


export { FormLoadingService };
